<template>
  <div>
    <Form @submit.native.prevent="preventSubmit" inline>
      <FormItem label="打包状态：" :label-width="84">
        <Select v-model="isPackaged" filterable transfer>
          <Option :value="2">全部</Option>
          <Option :value="1">已打包</Option>
          <Option :value="0">未打包</Option>
        </Select>
      </FormItem>
      <FormItem prop="keyword" label="房型名称：" :label-width="84">
        <Input type="text" v-model="keyword" placeholder="查询关键字"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="queryWithCondition">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="openAddRoomTypeModal">新增房型</Button>
      </FormItem>
    </Form>
    <Table stripe :loading="loading" height="650" :columns="columns" :data="data" style="margin-left: 2px;"></Table>
    <div style="margin: 10px;overflow: hidden">
      <Page show-sizer placement="top" :total="count" :current="page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>

    <Modal v-model="addRoomTypeModal.display" ref="addRoomTypeModal" :loading="true" :width="1000" title="新增渠道门店信息" @on-ok="preAddRoomType" ok-text="提交内容" cancel-text="关闭">
      <Form @submit.native.prevent="preventSubmit" ref="addRoomTypeModalForm" :model="addRoomTypeModal" :rules="addRoomTypeModal.rules" :label-width="150">
        <FormItem label="房型名称：" prop="name">
          <Input type="text" v-model="addRoomTypeModal.name"></Input>
        </FormItem>
        <FormItem  label="缓冲房量：" prop="bufferNum">
          <InputNumber v-model="addRoomTypeModal.bufferNum" :min="0" :max="100"></InputNumber>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import Utils from "@/utils";

export default {
  name: 'roomTypeList',
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.hotelId = Utils.getUrlParameterByName("hotelId");
  },
  props: {
    query: {
      type: Function,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns: [
        {
            title: "房型ID",
            key: "roomTypeId",
            align: "center",
            width: 150,
            fixed: "left"
          },
          {
            title: "房型名称",
            key: "roomTypeName",
            align: "center",
            width: 350
          },
          {
            title: "城市",
            key: "city",
            align: "center",
            width: 100
          },
          {
            title: "取价房",
            key: "city",
            align: "center",
            width: 100
          },
          {
            title: "打包数量",
            key: "packageRoomCount",
            align: "center",
            width: 200
          },
          {
            title: "缓冲房量",
            key: "bufferCount",
            align: "center",
            width: 200
          },
          {
            title: "在线状态",
            key: "bufferCount",
            align: "center",
            width: 200
          },
          {
            title: "匹配状态",
            key: "bufferCount",
            align: "center",
            width: 200
          },
          {
            title: "操作",
            align: "center",
            width: 240,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        if (this.$router) {
                          this.$router.push({
                            path: "/app/Ota/Ota/tujiaChannelRoomTypeDetail",
                            query: { roomTypeId: params.row.roomTypeId }
                          });
                        } else {
                          window.open(
                            `#/Ota/Ota/tujia/channelRoomTypeDetail?roomTypeId=${params.row.roomTypeId}`
                          );
                        }
                      }
                    }
                  },
                  "编辑打包"
                )
              ]);
            }
          }
      ],
      page: 1,
      pageSize: 10,
      isPackaged: 2,
      keyword: '',
      data: [], // 列表数据
      count: 0, // 列表总数
      addRoomTypeModal: {
        display: false,
        name: '',
        bufferNum: 0,
        rules: {
          name: [
            { required: true, message: "房型名称不能为空", trigger: "blur" }
          ]
        }
      }
    }
  },
  methods: {
    queryWithCondition() {

    },
    queryList() {

    },
    openAddRoomTypeModal() {
      this.initAddRoomTypeModal();

      this.addRoomTypeModal.display = true;
    },
    initAddRoomTypeModal() {
      this.addRoomTypeModal = Object.assign({}, this.addRoomTypeModal, {
        name: '',
        bufferNum: 0,
      })
    },
    preAddRoomType() {
      let validResult = true;
      this.$refs.addRoomTypeModalForm.validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        this.$refs.addRoomTypeModal.buttonLoading = false;
        return;
      }

      this.$emit('onConfirm', { name: this.addRoomTypeModal.name, bufferNum: this.addRoomTypeModal.bufferNum });

    },
    changePage(pageIndex) {
      this.page = pageIndex;
      this.queryList();
    },
    changePageSize(pageSize) {
      this.page = 1;
      this.pageSize = pageSize;
      this.queryList();
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/ota/tujia/hotel-detail/room-type-list.vue